import React, { useEffect, useRef, useState } from "react";
import { HttpGet, HttpGetDownload } from "../../providers/HttpClient";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Sheet } from "react-modal-sheet";
import axios from "axios";

const PayrollComponent: React.FC = () => {
  moment.locale("es");
  const [companyProfile, setCompanyProfile] = useState<any>(
    JSON.parse(localStorage.getItem("companyProfile")),
  );
  const [payrollData, setPayrollData] = useState<any>([]);
  const [hasMore, setHasMore] = useState(false);
  const [page, setPage] = useState(0);
  const [startDate, setStartDate] = useState<Date | null>(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  );
  const [endDate, setEndDate] = useState<Date | null>(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1),
  );

  const getPayrollData = async (pageNumber: number) => {
    const startPayDate = startDate
      ? moment(startDate).startOf("month").format("YYYY-MM-DD")
      : "";
    const endPayDate = endDate
      ? moment(endDate).endOf("month").format("YYYY-MM-DD")
      : "";

    let filterDate =
      startPayDate && endPayDate
        ? `&startPayDate=${startPayDate}&endPayDate=${endPayDate}`
        : "";
    await HttpGet(
      `member/payslip?page=${pageNumber}&size=10&isPublish=true${filterDate}`,
    ).then((res: any) => {
      const newData = res.data.content;

      if (newData.length < 1) {
        setHasMore(false);
      }

      setPayrollData((prev: any[]) =>
        pageNumber === 0 ? newData : [...prev, ...newData],
      );
    });
  };

  const downloadPayslip = async (id, date) => {
    try {
      const res = await HttpGetDownload(`member/payslip/download_pdf/${id}`);

      if (!res) return;

      const blob = new Blob([res.data], {
        type: res.headers["content-type"] || "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);

      let fileName = `Slip-Gaji-${date}.pdf`;

      const disposition = res.headers["content-disposition"];
      if (disposition) {
        const match = disposition.match(/filename="?(.+)"?/);
        if (match?.[1]) fileName = match[1];
      }

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download gagal:", err);
      alert(err);
    }
  };

  const handleLoadMore = () => {
    if (hasMore) {
      setPage((prev) => prev + 1);
    }
  };

  const handleDateRangeChange = ([newStartDate, newEndDate]: [
    Date | null,
    Date | null,
  ]) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    setPage(0);
    setHasMore(true);
  };

  useEffect(() => {
    if ((startDate && endDate) || (!startDate && !endDate)) {
      getPayrollData(page);
    }
  }, [page, startDate, endDate]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header
        style={{ backgroundColor: companyProfile?.color }}
        className="text-white p-4 rounded-b-xl shadow"
      >
        <h1 className="text-2xl font-bold">Slip Gaji</h1>
      </header>

      <div className="relative flex-1 overflow-y-auto p-4 space-y-4">
        <div className="flex justify-center">
          <DatePicker
            className="w-full rounded-lg border border-gray-300 px-4 py-3 text-center"
            startDate={startDate}
            endDate={endDate}
            onChange={handleDateRangeChange}
            dateFormat="MM/yyyy"
            placeholderText="Pilih rentang bulan gaji"
            showMonthYearPicker
            selectsRange
            isClearable
            // withPortal
          />
        </div>

        {payrollData?.map((item) => {
          return (
            <div className="bg-white rounded-lg shadow p-6">
              <div className="flex justify-between">
                <h2 className="text-base font-semibold">
                  Gaji - {moment(item.payDate).format("MMMM YYYY")}
                </h2>
                <div className="flex items-center">
                  <button
                    type="button"
                    className="bg-transparent px-4 py-2 rounded"
                    onClick={(e) =>
                      downloadPayslip(
                        item.id,
                        moment(item.payDate).format("MMMM YYYY"),
                      )
                    }
                  >
                    <FontAwesomeIcon
                      icon={"download"}
                      className="text-blue-500 text-lg"
                    />
                  </button>
                </div>
              </div>
            </div>
          );
        })}

        {hasMore ? (
          <div className="flex justify-center">
            <button
              onClick={handleLoadMore}
              className="bg-white rounded-xl shadow p-4 w-full hover:bg-gray-100 text-sm font-light transition"
            >
              Tampilkan lebih banyak
            </button>
          </div>
        ) : (
          <p className="text-center text-gray-500 text-sm font-light">
            Semua data telah ditampilkan
          </p>
        )}
      </div>
    </div>
  );
};

export default PayrollComponent;
